import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_CRM_API_URL;

const axios = createAxiosInstance(URL);

export const fetchUsers = async (params) => {
    const { results = [] } = await axios.get('/api/v1/users/users/', { params });

    return results;
};
